import { render, staticRenderFns } from "./sortingdo.vue?vue&type=template&id=89d4c522&scoped=true&"
import script from "./sortingdo.vue?vue&type=script&lang=js&"
export * from "./sortingdo.vue?vue&type=script&lang=js&"
import style0 from "./sortingdo.vue?vue&type=style&index=0&id=89d4c522&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d4c522",
  null
  
)

export default component.exports